import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router,Routes,Route, useRoutes } from 'react-router-dom';

const RoutesApp = () => {
  let routes = useRoutes([
    { path: "/", element: <App /> },
    { path: "/:ackmessage/", element: <App /> }
  ]);
  return routes;
};

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <RoutesApp />
      {/* <App /> */}
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
